import { ApiPropertyRegister } from '@foxeet/domain';

export type UtilsState = {
  propertyRegister: ApiPropertyRegister[];
};

export const initialState: UtilsState = {
  propertyRegister: [],
};
